export default __webpack_public_path__ + "static/media/Marquise@3x.5fa7d0e7.png";